<template>
  <div>
    <form>
      <div class="row ts-mb-2">
        <div class="col-lg-12">
          <div class="form-group">
            <label class="col-form-label control-label required">{{
              $t('restaurantSale.dateRange')
            }}</label>
            <a-range-picker style="width:100%" v-model="model.date_range" valueFormat="DD-MM-YYYY HH:mm"
              :show-time="{ format: 'HH:mm' }" format="DD-MM-YYYY HH:mm" />
            <div class="validate" v-if="errors.has('date_range')">
              {{ errors.first('date_range') }}
            </div>
          </div>
        </div>
      </div>
      <div class="row ts-mb-5">
        <div class="col-md-6">
          <a-radio-group v-model="model.print" button-style="solid">
            <a-radio-button value="a4" class="ts-w-24 ts-text-center">A4</a-radio-button>
            <a-radio-button value="receipt" class="ts-w-24 ts-text-center">Receipt</a-radio-button>
          </a-radio-group>
        </div>
        <div class="col-md-6 ts-flex ts-items-center">
          <div v-if="model.floating_id" class="ts-space-x-2">
            <a-switch v-model="model.is_shift_close" /> <span>{{ $t('restaurantSale.isShiftClose') }}</span>
          </div>
        </div>
      </div>
      <div class="row ts-space-y-2 ts-mb-2" v-if="model.is_shift_close">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6">
              <label class="ts-mb-0 required">
                {{ $t('floatingCashier.openingUsdBalance') }}
              </label>
              <ts-currency-input v-model.number="model.opening_usd_balance" class="form-control ts-text-right"
                style="min-width: 100px;height: 32px;" currency="$" :precision="2" :disabled="true" />
              <div class="validate" v-if="errors.has('opening_usd_balance')">
                {{ errors.first('opening_usd_balance') }}
              </div>
            </div>
            <div class="col-md-6">
              <label class="ts-mb-0 required">
                {{ $t('floatingCashier.openingKhrBalance') }}
              </label>
              <ts-currency-input v-model.number="model.opening_khr_balance" class="form-control ts-text-right"
                style="min-width: 100px;height: 32px;" currency="៛" :precision="0" :disabled="true" />
              <div class="validate" v-if="errors.has('opening_khr_balance')">
                {{ errors.first('opening_khr_balance') }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6">
              <label class="ts-mb-0 required">{{
                $t('floatingCashier.closingUsdBalance')
              }}</label>
              <ts-currency-input v-model.number="model.closing_usd_balance" class="form-control ts-text-right"
                style="min-width: 100px;height: 32px;" currency="$" :precision="2" />
              <div class="validate" v-if="errors.has('closing_usd_balance')">
                {{ errors.first('closing_usd_balance') }}
              </div>
            </div>
            <div class="col-md-6">
              <label class="ts-mb-0 required">{{
                $t('floatingCashier.closingKhrBalance')
              }}</label>
              <ts-currency-input v-model.number="model.closing_khr_balance" class="form-control ts-text-right"
                style="min-width: 100px;height: 32px;" currency="៛" :precision="0"
                :class="{ 'is-invalid': errors.has('closing_khr_balance') }" />
              <div class="validate" v-if="errors.has('closing_khr_balance')">
                {{ errors.first('closing_khr_balance') }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6">
              <label class="ts-mb-0 required">{{
                $t('floatingCashier.openingMemberCard')
              }}</label>
              <input v-model.number="model.opening_member_card" type="number" class="form-control" style="height: 32px;"
                :disabled="true" :class="{ 'is-invalid': errors.has('opening_member_card') }" />
            </div>
            <div class="col-md-6">
              <label class="ts-mb-0 required">{{
                $t('floatingCashier.closingMemberCard')
              }}</label>
              <input v-model.number="model.closing_member_card" type="number" class="form-control" style="height: 32px;"
                :class="{ 'is-invalid': errors.has('closing_member_card') }" />
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <label class="ts-mb-0">{{
            $t('floatingCashier.remark')
          }}</label>
          <textarea v-model="model.remark" rows="2" class="form-control" placeholder="Note something here"></textarea>
          <div class="validate" v-if="errors.has('remarks')">
            {{ errors.first('remarks') }}
          </div>
        </div>
      </div>
      <div class="row" v-if="is_required_pwd">
        <div class="form-group">
          <div class="col-md-12">
            <fieldset>
              <legend class="text-black">
                {{ $t('restaurantSale.adminConfirm') }}
              </legend>
              <div class="alert alert-danger fade show ts-mb-4" v-show="errorMessage != ''">
                {{ errorMessage }}
              </div>
              <div class="row form-group">
                <label class="col-form-label control-label required">
                  {{ $t('restaurantSale.username') }}</label>
                <input type="text" :placeholder="$t('restaurantSale.username')"
                  class="form-control form-control-md input-login" :class="{ 'is-invalid': errors.has('user_name') }"
                  v-model="model.user_name" />
                <div class="invalid-feedback" v-if="errors.has('user_name')">
                  {{ errors.first('user_name') }}
                </div>
              </div>
              <div class="row form-group">
                <label class="col-form-label control-label required">{{
                  $t('restaurantSale.password')
                }}</label>
                <a-input-password :placeholder="$t('restaurantSale.password')" v-model="model.password" />
                <div class="validate" v-if="errors.has('password')">
                  {{ errors.first('password') }}
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-right">
          <ts-button type="submit" class="btn-lg btn-block" color="primary" @click.prevent="ok" :waiting="waiting">{{
            $t('ok') }}</ts-button>
        </div>
      </div>
    </form>
    <reciept-preview v-model="pdf_view" :src_pdf="src" :show="pdf_view" @cancel="cancel" />
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import RecieptPreview from './reciept-preview'

export default {
  name: 'shiftClose',
  components: {
    RecieptPreview
  },
  data() {
    return {
      model: {
        counter_id: parseInt(localStorage.getItem('counterId')),
        print: 'receipt',
        user_name: null,
        password: null,
        is_admin_password: true,
        date_range: [
          moment().startOf('day').format('DD-MM-YYYY HH:mm'),
          moment().endOf('day').format('DD-MM-YYYY HH:mm')
        ],
        is_shift_close: false,
        opening_usd_balance: null,
        closing_usd_balance: null,
        opening_khr_balance: null,
        closing_khr_balance: null,
        opening_member_card: null,
        closing_member_card: null,
        floating_id: null,
        remark: null,
      },
      waiting: false,
      errorMessage: '',
      pdf_view: false,
      loading: false,
      src: '',
      errors: new Errors()
    }
  },
  created() {
    this.getPreData()
  },
  computed: {
    is_required_pwd() {
      return this.$store.state.restaurantSale.customerOrder.systemSettings
        .is_close_shift_require_pwd
    }
  },
  methods: {
    async getPreData(attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'restaurantSale/counterCheckout/fetchFloating',
          attributes
        )
        .then(response => {
          if (response.data) {
            this.model.opening_usd_balance = response.data.opening_usd_balance ? response.data.opening_usd_balance : null
            this.model.opening_khr_balance = response.data.opening_khr_balance ? response.data.opening_khr_balance : null
            this.model.opening_member_card = response.data.opening_member_card ? response.data.opening_member_card : null

            this.model.closing_member_card = response.data.opening_member_card ? (response.data.opening_member_card - response.data.member_sale) : null
            this.model.floating_id = response.data.floating_id ? response.data.floating_id : null
            if (response.data.first_in) {
              this.model.date_range = [response.data.first_in, response.data.first_out]
            }
          }
        })
        .catch(error => {
          this.$notification['error']({
            message: 'FETCH MEMBER CARD',
            description: error.message,
            placement: 'bottomRight'
          })
        })
        .finally(() => (this.loading = false))
    },
    ok() {
      this.errors = new Errors()
      this.errorMessage = ''
      this.loading = true
      this.waiting = true
      this.model.is_admin_password = this.is_required_pwd
      this.$store
        .dispatch('restaurantSale/counterCheckout/shiftClose', this.model)
        .then(response => {
          if (this.model.print == 'receipt') {
            if (this.model.is_shift_close) {
              this.cancel()
            }
          }
          if (this.model.print == 'a4') {
            this.pdf_view = true
            this.src = response.url
          }
        })
        .catch(errorResponse => {
          if (errorResponse.errors) {
            this.errors = new Errors(errorResponse.errors)
          } else if (errorResponse.message) {
            this.errorMessage = errorResponse.message
          }
          this.$notification['error']({
            message: 'Shift Close',
            description: errorResponse.message,
            placement: 'bottomRight'
          })
        })
        .finally(() => {
          this.loading = false
          this.waiting = false
        })
    },
    async logout() {
      await this.$store.dispatch('logout')
      this.$router.push({ name: 'login' })
    },
    cancel() {
      this.pdf_view = false
      this.$emit('cancel')
      this.logout()
    }
  }
}
</script>
<style scoped>
.btn-row .btn {
  padding: 15px 20px;
  font-size: 0.875rem;
  min-width: 100px;
  text-align: center;
  position: relative;
  border-radius: 0;
}

fieldset {
  border: 1px solid #ececec;
  padding: 10px 15px !important;
  border-radius: 4px;
}
</style>
